"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _jquery = _interopRequireDefault(require("jquery"));

var _axios = _interopRequireDefault(require("axios"));

var _semanticUiReact = require("semantic-ui-react");

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Shift4Iframe = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Shift4Iframe, _React$Component);

  var _super = _createSuper(Shift4Iframe);

  function Shift4Iframe(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Shift4Iframe);
    _this = _super.call(this, props);
    _this.handleSuccess = _this.handleSuccess.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFailure = _this.handleFailure.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadFailure = _this.handleLoadFailure.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Shift4Iframe, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var setLoading, handleSuccess, handleFailure, _yield$this$retrieveA, accessBlock;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setLoading = this.props.setLoading;
                handleSuccess = this.handleSuccess;
                handleFailure = this.handleFailure;
                setLoading(true);
                this.$el = (0, _jquery["default"])(this.el);
                window.jQuery = _jquery["default"];
                _context2.next = 8;
                return this.loadScript('https://i4m.i4go.com/js/jquery.i4goTrueToken.js');

              case 8:
                _context2.prev = 8;
                _context2.next = 11;
                return this.retrieveAccessBlock();

              case 11:
                _yield$this$retrieveA = _context2.sent;
                accessBlock = _yield$this$retrieveA.data;

                (function () {
                  var i4goConfig = {
                    server: accessBlock.i4go_server,
                    accessBlock: accessBlock.i4go_accessblock,
                    template: 'bootstrap2',
                    self: window.location,
                    url: accessBlock.i4go_i4m_url,
                    frameContainer: 'i4goFrame',
                    frameAutoResize: true,
                    submitButton: {
                      label: 'Submit'
                    },
                    onSuccess: function () {
                      var _onSuccess = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(form, data) {
                        return _regenerator["default"].wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                handleSuccess(data);

                              case 1:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee);
                      }));

                      function onSuccess(_x, _x2) {
                        return _onSuccess.apply(this, arguments);
                      }

                      return onSuccess;
                    }(),
                    onFailure: function onFailure(form, data) {
                      handleFailure(data);
                    },
                    acceptedPayments: 'AX,DC,MC,VS',
                    language: 'en',
                    label: {
                      classes: 'hidden'
                    },
                    cssRules: []
                  };
                  (0, _jquery["default"])('#form-main').i4goTrueToken(i4goConfig);
                  setLoading(false);
                })();

                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](8);
                this.handleLoadFailure(_context2.t0);
                setLoading(false);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 16]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "loadScript",
    value: function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        document.head.appendChild(script);

        script.onload = function () {
          resolve();
        };
      });
    }
  }, {
    key: "retrieveAccessBlock",
    value: function () {
      var _retrieveAccessBlock = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var locationId, host;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                locationId = this.props.locationId;
                host = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
                return _context3.abrupt("return", _axios["default"].get("".concat(host, "ordering/payments/locations/").concat(locationId, "/access_block/")));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function retrieveAccessBlock() {
        return _retrieveAccessBlock.apply(this, arguments);
      }

      return retrieveAccessBlock;
    }()
  }, {
    key: "handleSuccess",
    value: function handleSuccess(data) {
      var handleSuccess = this.props.handleSuccess;
      handleSuccess(data);
    }
  }, {
    key: "handleFailure",
    value: function handleFailure(data) {
      var handleFailure = this.props.handleFailure;
      handleFailure(data);
    }
  }, {
    key: "handleLoadFailure",
    value: function handleLoadFailure(data) {
      var handleLoadFailure = this.props.handleLoadFailure;
      handleLoadFailure(data);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Segment, {
        style: {
          margin: "0 -1rem"
        }
      }, /*#__PURE__*/_react["default"].createElement("form", {
        id: "form-main",
        action: "",
        method: "post"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        id: "i4go_response",
        name: "i4go_response",
        type: "hidden"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: "i4go_responsecode",
        name: "i4go_responsecode",
        type: "hidden"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: "i4go_responsetext",
        name: "i4go_responsetext",
        type: "hidden"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: "i4go_cardtype",
        name: "i4go_cardtype",
        type: "hidden"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: "i4go_maskedcard",
        name: "i4go_maskedcard",
        type: "hidden"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: "i4go_uniqueid",
        name: "i4go_uniqueid",
        type: "hidden"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: "i4go_expirationmonth",
        name: "i4go_expirationmonth",
        type: "hidden"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: "i4go_expirationyear",
        name: "i4go_expirationyear",
        type: "hidden"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: "i4go_cardholdername",
        name: "i4go_cardholdername",
        type: "hidden"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: "i4go_streetaddress",
        name: "i4go_streetaddress",
        type: "hidden"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: "i4go_postalcode",
        name: "i4go_postalcode",
        type: "hidden"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: "i4go_metatoken",
        name: "i4go_metatoken",
        type: "hidden"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(el) {
          return _this2.el = el;
        },
        id: "i4goFrame",
        style: {
          margin: '0 -1rem'
        }
      }));
    }
  }]);
  return Shift4Iframe;
}(_react["default"].Component);

exports["default"] = Shift4Iframe;